import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const ValidationTranslationKeys = {
  contractNumberExists: translationKey('validation_contract_number_exists'),
  dateMustBeIsoFormat: translationKey('validation_date_must_be_iso_format'),
  inputRequired: translationKey('validation_input_required'),
  inputValueShort: translationKey('validation_input_value_short'),
  invalidPhone: translationKey('validation_invalid_phone'),
  isRequired: translationKey('validation_is_required'),
  multiselectAmountAtLeastWeb: translationKey('validation_multiselect_amount_at_least_web'),
  multiselectAmountMaximumWeb: translationKey('validation_multiselect_amount_maximum_web'),
  numberLessThan: translationKey('validation_number_less_than'),
  numberMoreThan: translationKey('validation_number_more_than'),
  numberWrongDecimal: translationKey('validation_number_wrong_decimal'),
  numericMinMaxOrder: translationKey('validation_numeric_min_max_order'),
  numericSliderAllOrNone: translationKey('validation_numeric_slider_all_or_none'),
  numericStepExceedsRange: translationKey('validation_numeric_step_exceeds_range'),
  numericStepPositive: translationKey('validation_numeric_step_positive'),
  oneOf: translationKey('validation_one_of'),
  stringLengthAtLeastWeb: translationKey('validation_string_length_at_least_web'),
  stringLengthBetween: translationKey('validation_string_length_between'),
  stringLengthMaximumWeb: translationKey('validation_string_length_maximum_web'),
  userAlreadyExists: translationKey('validation_user_already_exists'),
  userUnauthorized: translationKey('validation_user_unauthorized'),
  valueMustBeEmail: translationKey('validation_value_must_be_email'),
} as const satisfies Record<string, TranslationKey>;
